export default function validateRecaptcha(value) {
  // Value will subsequently be validated server-side during order submission
  if (!value) return 'reCAPTCHA must be verified'
}
